import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50 dark:text-foreground-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/20">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold">打屁股视频大全</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">
              精选优质视频内容，涵盖亲子教育、影视赏析、搞笑短片、历史文化、动漫游戏与社会热点，为您带来丰富多彩的视听体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 cursor-pointer transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-50/70 hover:text-background-50 cursor-pointer transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-background-50/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@dapiguvideo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>dapigu_video</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-50/60">
          <p>&copy; 2026 打屁股视频大全 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-background-50/90 cursor-pointer transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50/90 cursor-pointer transition-colors">使用条款</a>
            <a href="#" className="hover:text-background-50/90 cursor-pointer transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}